<div class="kgr-alert kgr-alert--warning kgr-row" i18n>Diese Codes werden nur einmal angezeigt. Bitte jetzt sichern!</div>

<div class="backup-codes-grid kgr-row">
  @for (code of codes; track code) {
    <div class="backup-codes-grid__item">
      <code>{{ code }}</code>
    </div>
  }
</div>

<div class="kgr-postfix kgr-postfix--gutters">
  <div class="kgr-postfix__fixed">
    <button type="button" class="kgr-button kgr-button--secondary" (click)="copy()">
      <svg kgrIcon="share" class="kgr-button__icon kgr-button__icon--left"></svg>
      <ng-container i18n>Kopieren</ng-container>
    </button>
  </div>
  <div class="kgr-postfix__fixed">
    <button type="button" class="kgr-button kgr-button--secondary" (click)="download()">
      <svg kgrIcon="save" class="kgr-button__icon kgr-button__icon--left"></svg>
      <ng-container i18n>Download</ng-container>
    </button>
  </div>
</div>
